const UUID_RE = /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi;
const NUMERIC_ID_RE = /\/\d+(?=\/|$)/g;

// Collapse dynamic segments (UUIDs, numeric ids, querystrings) so that
// /agencies/<uuid> and /agencies/<other-uuid> share a templated route.
// Used for Sentry fingerprinting and PostHog pageview enrichment.
export function normalizeRoute(url) {
  if (!url) return "";
  const path = url.split("?")[0];
  return path.replace(UUID_RE, ":id").replace(NUMERIC_ID_RE, "/:id");
}
